<template>
  <p>

    <template v-if="[null,undefined,''].indexOf(address.premises)===-1">
      <template v-if="bold"><b>{{address.premises}}</b></template>
      <template v-else>{{address.premises}}</template><br>
    </template>

    <template v-if="[null,undefined,''].indexOf(address.number)===-1">
      <template v-if="bold"><b>{{address.number}}</b></template>
      <template v-else>{{address.number}}</template><br>
    </template>

    <template v-if="[null,undefined,''].indexOf(address.street)===-1">
      <template v-if="bold"><b>{{address.street}}</b></template>
      <template v-else>{{address.street}}</template><br>
    </template>

    <template v-if="[null,undefined,''].indexOf(address.line_one)===-1">
      <template v-if="bold"><b>{{address.line_one}}</b></template>
      <template v-else>{{address.line_one}}</template><br>
    </template>

    <template v-if="[null,undefined,''].indexOf(address.line_two)===-1">
      <template v-if="bold"><b>{{address.line_two}}</b></template>
      <template v-else>{{address.line_two}}</template><br>
    </template>

    <template v-if="[null,undefined,''].indexOf(address.city)===-1">
      <template v-if="bold"><b>{{address.city}}</b></template>
      <template v-else>{{address.city}}</template><br>
    </template>

    <template v-if="[null,undefined,''].indexOf(address.post_code)===-1">
      <template v-if="bold"><b>{{address.post_code}}</b></template>
      <template v-else>{{address.post_code}}</template><br>
    </template>

    <template v-if="[null,undefined,''].indexOf(address.country)===-1">
      <template v-if="bold"><b>{{address.country}}</b></template>
      <template v-else>{{address.country}}</template><br>
    </template>

    <template v-if="[null,undefined,''].indexOf(address.county)===-1">
      <template v-if="bold"><b>{{address.county}}</b></template>
      <template v-else>{{address.county}}</template><br>
    </template>

  </p>
</template>

<script>
  export default {
    props: ['address','bold'],
  }
</script>

<style lang="scss" scoped></style>
